@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: content;
}
